export const staticPageEditorMeta = { title: 'Static Page Editor'};
